import request from '@/utils/request'

/**
 * 获取用户退款订单列表
 * @param {Object} params 查询参数
 * @param {String} params.personId 用户ID
 * @param {Number} params.page 页码
 * @param {Number} params.row 每页条数
 */
export function getRefundOrderList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/refundOrder.queryAdminRefundOrders',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}